// Original brand mark for Myriad View Limited (Canada) — not copied from any source
export default function Logo({ className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="mvGrad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
            <stop stopColor="#39d3e6" />
            <stop offset="0.5" stopColor="#4f7dff" />
            <stop offset="1" stopColor="#9ee04a" />
          </linearGradient>
        </defs>
        <path d="M20 3.5c9.11 0 16.5 7.39 16.5 16.5S29.11 36.5 20 36.5" stroke="url(#mvGrad)" strokeWidth="3.4" strokeLinecap="round" fill="none" />
        <path d="M20 8.5A11.5 11.5 0 1 0 20 31.5" stroke="#9ee04a" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.9" />
        <circle cx="20" cy="20" r="3.6" fill="#39d3e6" />
      </svg>
      <div className="leading-none">
        <span className="font-display text-[19px] font-bold tracking-tight text-white">Myriad</span>
        <span className="block text-[9px] font-semibold tracking-[0.28em] text-brand-lime">VIEW • CANADA</span>
      </div>
    </div>
  );
}
